import * as React from "react";

import CategoryPage, { CategoryPageProps } from "./CategoryPage";

function TopicCategoryPage(
  props: Omit<CategoryPageProps, "searchCategoryType" | "title" | "subtitle">,
) {
  return (
    <CategoryPage
      title="Search procurement activity by topic or CPV code"
      subtitle="Browse all government procurement activity by specific topic or CPV code below."
      searchCategoryType="topic"
      {...props}
    />
  );
}

export default TopicCategoryPage;
